import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import { WhoppahCourierFast } from "@/assets/icons/24/WhoppahCourierFast";
import { ProductDeliveryOptionItemProps } from "@/features/product-delivery-options/components/ProductDeliveryOptionItem";
import { ProductDeliveryOptionItemRow } from "@/features/product-delivery-options/components/ProductDeliveryOptionItemRow";
import { getProductDeliveryPriceLabel } from "@/features/product-delivery-options/components/utils/product-delivery-options.utils";

export const ProductDeliveryOptionItemCustom = ({
  option,
  loading,
}: ProductDeliveryOptionItemProps) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const { label, isFree } = getProductDeliveryPriceLabel(option, t, locale);

  return (
    <ProductDeliveryOptionItemRow
      method="custom"
      icon={<WhoppahCourierFast className="size-6 shrink-0 text-brand-500" />}
      title={t("pdp:pdp-usp-shipping-title-custom-v2")}
      subtitle={t("pdp:pdp-usp-shipping-line-custom-arrangements")}
      priceLabel={label}
      isFree={isFree}
      loading={loading}
    />
  );
};
